/**
 * Affichage canonique d'un utilisateur dans l'UI : "Prénom Nom".
 * Tombe sur email puis NDC si nom/prénom indisponibles (cas legacy).
 */
export function formatUserName(user) {
  if (!user) return '—'
  if (user.fullName) return user.fullName
  if (user.prenom && user.nom) return `${user.prenom} ${user.nom}`
  if (user.prenom) return user.prenom
  if (user.nom) return user.nom
  return user.email || user.ndc || '—'
}
